import { render, staticRenderFns } from "./ItemsImport.vue?vue&type=template&id=4d1e59b9&"
import script from "./ItemsImport.vue?vue&type=script&lang=js&"
export * from "./ItemsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports